module.exports = __webpack_public_path__ + "static/img-iphone-dashboard.4aa9470d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-iphone-dashboard.png
// module id = 790
// module chunks = 65120233804887